import React from "react";
import NavBar from "../components/NavBar";

const FoodyDeleteAccountPage = ({ language, onLanguageChange, t }) => {
  const requestItems = t("foodyDelete.request.items") || [];

  return (
    <div className="page foody-page support-page" id="foody-delete-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/foody", label: t("foodySupport.back") },
          {
            href: "/apps/foody/static/support",
            label: t("foodySupport.badge"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("foodyDelete.badge")}</span>
            <h1>{t("foodyDelete.hero.title")}</h1>
            <p>{t("foodyDelete.hero.desc")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("foodyDelete.inApp.title")}</h3>
              <p>{t("foodyDelete.inApp.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyDelete.request.title")}</h3>
              <p>{t("foodyDelete.request.desc")}</p>
              <ul className="support-list">
                {requestItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p className="support-muted">{t("foodyDelete.request.footer")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foodyDelete.contact.title")}</h2>
            <p>
              {t("foodyDelete.contact.desc")}
              <br />
              <a href="mailto:support-foody@wodaslabs.com?subject=Foody%20Account%20Deletion%20Request">
                support-foody@wodaslabs.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodyDeleteAccountPage;
